import { render } from "./MyDataTab.vue?vue&type=template&id=971298e2&scoped=true"
import script from "./MyDataTab.vue?vue&type=script&lang=js"
export * from "./MyDataTab.vue?vue&type=script&lang=js"

import "./MyDataTab.vue?vue&type=style&index=0&id=971298e2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-971298e2"

export default script